import { createFileRoute, redirect } from "@tanstack/react-router";
import DealerLegacyRedirect from "@/pages/DealerLegacyRedirect";
import { supabase } from "@/integrations/supabase/client";
import { dealerHead } from '@/lib/seo/dealer-seo';
import { resolveDealerAlias } from '@/lib/dealerCanonical.functions';

export const Route = createFileRoute("/dealer/$dealerId/")({
  loader: async ({ params, context }) => {
    const alias = await resolveDealerAlias({ data: { id: params.dealerId } });
    if (typeof alias === 'string' && alias) {
      throw redirect({ to: '/dealeri/$alias', params: { alias }, statusCode: 301 });
    }
    // Dealers without an alias retain the existing profile and its public access rules.
    const { data: dealer, error: profileError } = await supabase.from('dealer_profiles')
      .select('id,user_id,business_name,company_name,showroom_name,city,company_description,description,logo_url,cover_image_url,verified,risco_verified,verification_status,created_at,average_rating,total_reviews,years_in_business')
      .or(`id.eq.${params.dealerId},user_id.eq.${params.dealerId}`).maybeSingle();
    if (profileError) throw profileError;
    if (!dealer) return null;
    context.queryClient.setQueryData(['dealer-profile', params.dealerId], dealer);
    const { data: rows, error: rowsError } = await supabase.from('listings_v2')
      .select('id,make,model,year,price,mileage_value,mileage_unit,attributes,photos,currency,status,location_city,location_region,created_at')
      .eq('user_id', dealer.user_id).eq('status', 'active').order('created_at', { ascending: false });
    if (rowsError) throw rowsError;
    context.queryClient.setQueryData(['dealer-listings', params.dealerId], {
      listings: (rows ?? []).map(item => ({ id: item.id, make: item.make, model: item.model, year: item.year, price: item.price, mileage: item.mileage_value ?? 0, fuel_type: '', images: item.photos, currency: item.currency })),
      contactPhone: null, contactEmail: null, contactAddress: null,
    });
    return { alias: null, dealer, listings: [] };
  },
  head: ({ params, loaderData }) => {
    const dealer = loaderData?.dealer;
    const name = dealer?.company_name || dealer?.showroom_name || (dealer && 'business_name' in dealer ? dealer.business_name : null);
    return dealerHead(`/dealer/${params.dealerId}`, typeof name === 'string' ? name : null, dealer?.city ?? null);
  },
  component: DealerLegacyRedirect,
});
